/**
 * @generated SignedSource<<be1419c65104b3e577638ff312c57b54>>
 * @relayHash 5b9f5dfbc735f0315714ce125c523809
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 51fd0a9ce56ef210c99c16c9e4e3e06153162ea9a26fb12e627eb645b84b7e87

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { decomposedStoryPointEstimateFieldQuery } from './decomposedStoryPointEstimateFieldQuery.graphql';

const node: PreloadableConcreteRequest<decomposedStoryPointEstimateFieldQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "51fd0a9ce56ef210c99c16c9e4e3e06153162ea9a26fb12e627eb645b84b7e87",
    "metadata": {},
    "name": "decomposedStoryPointEstimateFieldQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
